import { request } from "@/Api";

export let serviceItems = [];
export let internalServiceItems = [];

export const getServiceItemsByCategory = (category) => {
    return serviceItems.filter(
        (item) => item.category == category && item.currency == "CAD",
    );
};

export const getServiceItems = () => {
    request.get("service-items").then((response) => {
        serviceItems = [...response.data];
        internalServiceItems = response.data.filter(
            (item) =>
                item.internal_rate != null && item.internal_markup != null,
        );
    });
};
